import { isEmpty } from '@intelligence/v3/utils/common';
import { getOptionText } from '@intelligence/utils/topchartsUtils';
import { LANGUAGE_CN, LANGUAGE_EN } from '@home/_config/config';
import {
  DATASOURCE_KEY_MAP,
  GSD_METRIC_KEY_MAP,
  MSCIENCE_METRIC_KEY_MAP,
  NPD_METRIC_KEY_MAP,
  NEWZOO_METRIC_KEY_MAP,
} from '@intelligence/v3/_config/metrics/keyMap';
import { COMBINE_DATA_SOURCES_METRICS_MAPPING } from '@intelligence/v3/_config/metrics/combine';

const getMetricName = (locale: string, dataSource: string, metric: string, metricName?: string): string => {
  if (!isEmpty(metricName)) return metricName!;
  const metricData = COMBINE_DATA_SOURCES_METRICS_MAPPING[dataSource]?.[metric] ?? {};
  const metricNameData = metricData?.metricName;
  // @ts-ignore
  return getOptionText(locale, { textEN: metricNameData?.en, textCN: metricNameData?.cn });
};

/** *********************************************** GSD数据源指标名称 *********************************************** **/
/**
 * GSD数据源Total Revenue指标
 */
export const GSD_TOTAL_REVENUE_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.TOTAL_REVENUE),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.TOTAL_REVENUE),
};

/**
 * GSD数据源Digital Revenue指标
 */
export const GSD_DIGITAL_REVENUE_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.DIGITAL_REVENUE),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.DIGITAL_REVENUE),
};

/**
 * GSD数据源Physical Revenue指标
 */
export const GSD_PHYSICAL_REVENUE_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.PHYSICAL_REVENUE),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.PHYSICAL_REVENUE),
};

/**
 * GSD数据源Total Units指标
 */
export const GSD_TOTAL_UNITS_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.TOTAL_UNITS),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.TOTAL_UNITS),
};

/**
 * GSD数据源Digital Units指标
 */
export const GSD_DIGITAL_UNITS_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.DIGITAL_UNITS),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.DIGITAL_UNITS),
};

/**
 * GSD数据源Physical Units指标
 */
export const GSD_PHYSICAL_UNITS_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.PHYSICAL_UNITS),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.GSD, GSD_METRIC_KEY_MAP.PHYSICAL_UNITS),
};
/** *********************************************** GSD数据源指标名称 *********************************************** **/

/** *********************************************** MScience数据源指标名称 *********************************************** **/
/**
 * MScience数据源Digital Revenue指标
 */
export const MSCIENCE_DIGITAL_REVENUE_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.GSD, MSCIENCE_METRIC_KEY_MAP.DIGITAL_REVENUE),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.GSD, MSCIENCE_METRIC_KEY_MAP.DIGITAL_REVENUE),
};

/**
 * MScience数据源Digital Units指标
 */
export const MSCIENCE_DIGITAL_UNITS_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.GSD, MSCIENCE_METRIC_KEY_MAP.DIGITAL_UNITS),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.GSD, MSCIENCE_METRIC_KEY_MAP.DIGITAL_UNITS),
};
/** *********************************************** MScience数据源指标名称 *********************************************** **/

/** *********************************************** npd数据源指标名称 *********************************************** **/
/**
 * NPD数据源Physical Revenue指标
 */
export const NPD_PHYSICAL_REVENUE_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.GSD, NPD_METRIC_KEY_MAP.PHYSICAL_REVENUE),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.GSD, NPD_METRIC_KEY_MAP.PHYSICAL_REVENUE),
};

/**
 * NPD数据源Physical Units指标
 */
export const NPD_PHYSICAL_UNITS_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.GSD, NPD_METRIC_KEY_MAP.PHYSICAL_UNITS),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.GSD, NPD_METRIC_KEY_MAP.PHYSICAL_UNITS),
};
/** *********************************************** npd数据源指标名称 *********************************************** **/

/** *********************************************** newzoo数据源指标名称 *********************************************** **/
/**
 * Newzoo数据源Total Revenue指标
 */
export const NEWZOO_TOTAL_REVENUE_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.NEWZOO, NEWZOO_METRIC_KEY_MAP.TOTAL_REVENUE),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.NEWZOO, NEWZOO_METRIC_KEY_MAP.TOTAL_REVENUE),
};

/**
 * Newzoo数据源Total Players指标
 */
export const NEWZOO_TOTAL_PLAYERS_METRIC_NAME: IRecord<string> = {
  [LANGUAGE_EN]: getMetricName(LANGUAGE_EN, DATASOURCE_KEY_MAP.NEWZOO, NEWZOO_METRIC_KEY_MAP.TOTAL_PLAYERS),
  [LANGUAGE_CN]: getMetricName(LANGUAGE_CN, DATASOURCE_KEY_MAP.NEWZOO, NEWZOO_METRIC_KEY_MAP.TOTAL_PLAYERS),
};
/** *********************************************** newzoo数据源指标名称 *********************************************** **/
